import React from 'react'
import { useState, useRef } from 'react';
import { ApiHelper } from '../../utilFunctions/utilfunction';
import { useForm } from 'react-hook-form';
import '../homepage/homepage.css';
import SubmitIcon from '../../assets/contactus/submit.svg';
import ReCAPTCHA from 'react-google-recaptcha';
import { useNavigate } from 'react-router';
import './auth.css'

import { Eye, EyeOff } from "lucide-react";
const ChangePassword = () => {
    const dangerous = useRef(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setshowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    // For message which display when submit the form
    const [flashmessage, setFlashmessage] = useState(false);
    const togglePassword = () => setShowPassword((prev) => !prev);
    const toggleNewPassword = () => setshowNewPassword((prev) => !prev);
    const [isRecaptchaError, setIsRecaptchaError] = useState(false);
    const toggleConfirmPassword = () => setShowConfirmPassword((prev) => !prev);
    // For recaptcha
    const [recaptcha, setRecaptcha] = useState(true);
    const [isError, setIsError] = useState(false);
    // For validation
    
    const [messagess, setMessagess] = useState("");
    const navigate = useNavigate();
    // console.log(messagess);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
        trigger,
    } = useForm();

    const Submit = async (event) => {
        const { current_password, new_password } = event;
        if (recaptcha) {
           
            setIsRecaptchaError(true);
            return; 
        } else {
            setIsRecaptchaError(false);
        }
        setLoading(true)
        const reqToSend = {
            current_password,
            new_password,
        };

        const token = localStorage.getItem("access_token"); // or whatever your token key is

        const headers = {
            Authorization: `Bearer ${token}`,
        };

        try {
            const response = await ApiHelper("/change-password", reqToSend, "POST", headers);

            if (response?.status === true) {
                setIsError(false);
                setMessagess(response?.message);
                setFlashmessage(true);


            } else {
                const errorMsg = response?.message || "Change password failed.";

                setIsError(true);
                setMessagess(errorMsg);
                setFlashmessage(true);
            }
        } catch (error) {
            setMessagess("Something went wrong.");
            setFlashmessage(true);
        } finally {
            setLoading(false)
            setTimeout(() => {
                setFlashmessage(false);
                setMessagess("");
                setIsError(false);
            }, 10000);
        }

    };

    const handleChange = (value) => {
        if (value) {
            setRecaptcha(false); 
            setIsRecaptchaError(false); 
        } else {
            setRecaptcha(false);
        }
    };
    return (
        <section className="contactus p-navbar">
            <div className="common_form container pt-5 ps-lg-0 pe-lg-0">
                <h4 className="fw-bold text-uppercase fs-18">Change Password</h4>

                {/*** Form ***/}
                <div className="d-flex justify-content-center">
                    <form className="form pt-4" onSubmit={handleSubmit(Submit)} style={{ width: '100%' }}>
                        <div className="row d-flex flex-wrap justify-content-between">
                            <div className="col-12 col-lg-6 pe-lg-4">
                                <div className="textOnInput">
                                    <input
                                        className="form-control"
                                        type={showPassword ? "text" : "password"}
                                        {...register("current_password", { required: "Current Password is required" })}
                                        onKeyUp={() => {
                                            trigger("current_password");
                                        }}
                                    />
                                    <span
                                        onClick={togglePassword}
                                        className="position-absolute end-0 translate-middle-y me-3 cursor-pointer"
                                        style={{ top: errors.password ? '33%' : '50%', }}

                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                    {errors.current_password && (
                                        <p className="position-absolute text-danger">
                                            {errors.current_password.message}
                                        </p>
                                    )}
                                    <label htmlFor="inputText" style={{ backgroundColor: 'white' }}>Current Password*</label>
                                </div>
                                <div className="textOnInput">
                                    <input
                                        className="form-control"
                                        type={showNewPassword ? "text" : "password"}
                                        {...register("new_password", { required: "New Password is required" })}
                                        onKeyUp={() => {
                                            trigger("new_password");
                                        }}
                                    />
                                    <span
                                        onClick={toggleNewPassword}
                                        className="position-absolute end-0 translate-middle-y me-3 cursor-pointer"
                                        style={{ top: errors.password ? '33%' : '50%', }}

                                    >
                                        {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                    {errors.new_password && (
                                        <p className="position-absolute text-danger">
                                            {errors.new_password.message}
                                        </p>
                                    )}
                                    <label htmlFor="inputText" style={{ backgroundColor: 'white' }}>New Password*</label>
                                </div>
                                <div className="textOnInput">
                                    <input
                                        className="form-control"
                                        type={showConfirmPassword ? "text" : "password"}

                                        {...register("confirm_password", {
                                            required: "Confirm Password is required",
                                            validate: (value) => value === watch("new_password") || "Passwords do not match"
                                        })}
                                        onKeyUp={() => {
                                            trigger("confirm_password");
                                        }}
                                    />
                                    <span
                                        onClick={toggleConfirmPassword}
                                        className="position-absolute end-0 translate-middle-y me-3 cursor-pointer"
                                        style={{ top: errors.password ? '33%' : '50%', }}

                                    >
                                        {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </span>
                                    {errors.confirm_password && (
                                        <p className="position-absolute text-danger">
                                            {errors.confirm_password.message}
                                        </p>
                                    )}
                                    <label htmlFor="inputText" style={{ backgroundColor: 'white' }}>Confirm Password*</label>
                                </div>
                            </div>
     
                            <ReCAPTCHA
                                id="recaptcha"
                                sitekey={siteKey || ""}
                                onChange={handleChange}
                            />
                            {isRecaptchaError && recaptcha && (
                                            <span className="text-danger d-block" style={{ fontSize: 16 }}>
                                                Please verify the captcha.
                                            </span>
                                        )}
                            <div className="d-flex flex-wrap mt-md-5 mt-lg-4 align-items-center gap-4">
                                <button
                                    type="button"
                                    className="fw-600 btn cancel_button "
                                    onClick={() => navigate(-1)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="fw-600 btn hover2 submit_button"
                                    
                                >
                                    Submit
                                </button>
                                {loading && (
                                <div className="spinner-border text-light align-self-center" style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    borderWidth: "0.2em",
                                    borderColor: "#ccc", // All borders
                                    borderTopColor: "#333", // Spinner color
                                }} role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            )}
                                {flashmessage && messagess && (
                                    <div className={`d-flex mt-1 align-items-center pt-2 pt-sm-0 ${isError ? 'text-danger' : 'text-black'}`}>
                                        {!isError && <img className="ps-sm-4 pe-2" src={SubmitIcon} alt="" />}
                                        <span className='fs-5'>{messagess}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </form>
                </div>

            </div>


        </section>
    )
}

export default ChangePassword
